import { useEffect } from 'react';
import { screenLog } from '../../../shared/lib/logging';
import { useTimer } from '../../../shared/hooks/useTimer';
import { EVENT_NAMES, TimeoutScreen, useSendEventLog } from '../../event-log';

interface UseTimerTimeoutParams {
    screenName: TimeoutScreen;
    onTimeout: () => void;
    duration?: number;
}

export function useTimerTimeout({ screenName, onTimeout, duration }: UseTimerTimeoutParams) {
    const timerHook = useTimer(duration);
    const { sendTimeout } = useSendEventLog();

    useEffect(() => {
        screenLog(screenName);
        timerHook.start();
        return () => timerHook.reset();
    }, []);

    useEffect(() => {
        if (timerHook.time <= 0) {
            sendTimeout({ name: EVENT_NAMES.timeout[screenName] });
            timerHook.reset();
            onTimeout();
        }
    }, [timerHook.time]);

    return timerHook;
}
